<template>
  <SimpleModuleDashboard
    :module-id="Modules.INSTANCIAS"
    :profile-id="Profiles.PERSONAL"
    include-php-custom
    :actions="actions"
    :widget-filter="filterWidgets"
  />
</template>

<script>
import Profiles from '@/config/profiles'
import Modules from '@/config/modules'
import Param from '@/config/parameters'
import Helper from '@/handler/helper'
import SimpleModuleDashboard from '@/components/inc/dashboard/SimpleModuleDashboard'

export default {
  components: { SimpleModuleDashboard },
  data: () => ({
    Modules,
    Profiles,
    integrateServices: Helper.hasParametersAccess(Param.P59),
    actions: [
      { id: 'crudInstancesMonitorServer', reference: 'crudInstancesMonitorServer', route: 'InstancesStaffCrudInstancesMonitorServer', tone: 'secondary' },
      { id: 'crudInstancesMonitorSystem', reference: 'crudInstancesMonitorSystem', route: 'InstancesStaffCrudInstancesMonitorSystem', tone: 'success' },
      { id: 'crudInstancesCategories', reference: 'crudInstancesCategories', route: 'InstancesStaffCrudInstancesCategories', tone: 'primary', group: 'Configuraciones' },
      { id: 'configInstances', reference: 'configInstances', route: 'InstancesStaffConfigInstances', tone: 'primary', group: 'Configuraciones' },
    ],
  }),
  methods: {
    filterWidgets(widget) {
      return widget.reference !== 'list_without_services' || this.integrateServices
    },
  },
}
</script>
